import { useMemo } from 'react';
import { components, GroupBase, MultiValueRemoveProps } from 'react-select';
import { getColor } from '@/utils/getThemeColor';
import CloseIcon from '@icons/close_icon.svg?component';
import { Obj } from '@/types/common';
import { DEFAULT_DELETE_ICON_COLOR } from './constants';
import { MultiValueRemoveOptions } from './types';

export function MultiValueRemove<T extends Obj>(
  props: MultiValueRemoveProps<T, boolean, GroupBase<T>>,
  options?: MultiValueRemoveOptions<T>
): JSX.Element {
  const color = useMemo(() => {
    return options?.strokeDataKey
      ? getColor(props.data[options.strokeDataKey], DEFAULT_DELETE_ICON_COLOR)
      : DEFAULT_DELETE_ICON_COLOR;
  }, [options, props.data]);

  return (
    <components.MultiValueRemove {...props}>
      <CloseIcon
        key={props.selectProps.getOptionValue(props.data)}
        height={9}
        width={9}
        style={{ color }}
      />
    </components.MultiValueRemove>
  );
}
